// extracted by mini-css-extract-plugin
module.exports = {"container":"_25d45facb5--container--hQkSM","logo":"_25d45facb5--logo--jPdhz"};